import type { FaireCategoryEntity } from "../../entity_types/category";

export const cat_women_kimonos: FaireCategoryEntity = {
  token: "cat_women-kimonos",
  type: "category",
  name: "Kimonos & kaftans",
  level: 3,
  parentToken: "cat_apparel-women",
  href: "/category/women/kimonos-kaftans",
  meta: {
    source: "mock" as const,
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
